import { FilesContainer } from 'modules/files';
import type { LeadCloudFileType } from '@econtractor/types';

interface PaymentCloudFilesProps {
    paymentId: number;
    files: LeadCloudFileType[];
}

const PaymentCloudFiles = ({ paymentId, files }: PaymentCloudFilesProps) => {
    if (!Array.isArray(files) || !files.length) return null;

    return (
        <FilesContainer
            files={files}
            scope={{ paymentId: Number(paymentId || 0) }}
            imageColProps={{ xs: 6, md: 4, lg: 3 }}
            canEdit={false}
            addButtonLabel=""
            uploadingLabel=""
            saveFirstMessage=""
            errorMessage=""
            uploadSuccessMessage=""
            onFilesChange={async () => true}
        />
    );
};

export default PaymentCloudFiles;
